import { StepConnector, styled } from "@mui/material";

const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
    "& .MuiStepConnector-line": {
      borderColor: "#e0e0e0",
      borderTopWidth: 3,
      borderRadius: 1,
      margin: "7px 30px 20px 30px",
    },
  }));

export default CustomStepConnector;